import styled from "styled-components";

import Accordion from '@material-ui/core/Accordion';

export const AccordionStyled = styled(Accordion)`
    border-radius: 18px;
    box-shadow: none !important;
    border: none;
    background: #ece9e9;
    margin: 10px 0px;

    &&:before {
      content: '';
      border: none;
      width: 0;
      height: 0;
    }

    & > div {
      box-shadow: none;
    }

    .MuiAccordionSummary-root {
    border-radius: 18px;
    background: #ece9e9;
    border: none;
    box-shadow: none;
    }

    .MuiCollapse-wrapper {
      padding: 10px 0px 0px 0px;
    }

    .MuiCollapse-wrapperInner {
      width: auto;
    }

    .MuiPaper-root, .MuiPaper-elevation, .MuiPaper-rounded, .MuiPaper-elevation1, .MuiAccordion-root, .MuiAccordion-rounded, .MuiAccordion-gutters {
      border: none;
      box-shadow: none;
    }

&&:last-child, &&:first-child {
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    border-bottom-left-radius: 18px;
    border-bottom-right-radius: 18px;
    box-shadow: none;
    border: none;
}
`;

export const NothingParcelament = styled.div`
  font-size: 16px;
  color: #837775;
  width: 100%;
  border-radius: 18px;
  box-shadow: none;
  border: none;
  background: #ece9e9;
  text-align: center;
  box-sizing: border-box;
  padding: 15px;
`;

export const List = styled.div`
    width: auto;

    li {
      padding: 2px 0;
      list-style: none;
      padding: 5px 20px;
      border-radius: 5px;

      &:nth-child(odd){
        background: rgba(0,0,0,0.100);
      }
    }
`;
